import React, { useMemo } from 'react'
import useNotifications from '../hooks/use-notifications'
import { NotificationContext } from './notification-context'
import { NotificationContextProps } from '../types'

interface Props {
  children?: React.ReactNode
}

/**
 * Provides notification context based on the use-notification state handling hook
 */
const NotificationProvider: React.VFC<Props> = ({ children }) => {
  const {
    notifications,
    unreadNotificationsCount,
    limitedNotifications,
    unreadNotifications,
    mandatoryNotifications,
    loadNotifications,
    loadLimitedNotifications,
    loadUnreadNotificationsCount,
    loadNotificationStats,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    offset,
    setOffset,
    limit,
    setLimit,
    notificationsCount,
    getMandatoryNotifications,
  } = useNotifications()

  const value: NotificationContextProps = useMemo(
    () => ({
      notifications,
      limitedNotifications,
      unreadNotificationsCount,
      unreadNotifications,
      mandatoryNotifications,
      loadNotifications,
      loadLimitedNotifications,
      loadNotificationStats,
      loadUnreadNotificationsCount,
      markNotificationAsRead,
      markAllNotificationsAsRead,
      getMandatoryNotifications,
      offset,
      setOffset,
      limit,
      setLimit,
      notificationsCount,
    }),
    [
      limit,
      limitedNotifications,
      loadLimitedNotifications,
      loadNotificationStats,
      loadNotifications,
      loadUnreadNotificationsCount,
      mandatoryNotifications,
      markAllNotificationsAsRead,
      markNotificationAsRead,
      notifications,
      notificationsCount,
      offset,
      setLimit,
      setOffset,
      unreadNotifications,
      unreadNotificationsCount,
      getMandatoryNotifications,
    ]
  )

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>
}

export default NotificationProvider
